import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteImage = function SvgRteImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.5A1.5 1.5 0 016.5 5h11A1.5 1.5 0 0119 6.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 17.5v-11zm5 2a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm6.508 8.535h-9c-.319 0-.64-.548-.453-.805l2.217-3.078a.388.388 0 01.56-.008l1.176 1.89s2.337-3.623 2.5-3.856c.164-.233.528-.241.676 0l2.793 5.161c.14.265-.173.696-.469.696z",
    fill: "#5C5F62"
  })));
};
var rteImage = SvgRteImage;

export { rteImage as default };
